import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/sanity-docs/app/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/sanity-docs/lib/registry.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/vapor-theme/build/web/variables-combined.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/vapor/dist/esm/style.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/sanity-docs/app/global.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./FrameGothic-Variable.ttf\",\"preload\":true,\"variable\":\"--frame-gothic\"}],\"variableName\":\"frameGothic\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"preload\":true,\"variable\":\"--inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Roboto_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"preload\":false,\"variable\":\"--roboto\"}],\"variableName\":\"roboto\"}");
